import React from "react";
import "../../App.css";

export default function Marketing() {
  return (
    <>
      <h1 className="marketing">Marketing</h1>
    </>
  );
}
